(() => {
  if (window.astralDirectBuyV2TestInitialized) return;
  window.astralDirectBuyV2TestInitialized = true;

  const shopRoot = window.Shopify?.routes?.root || '/';

  async function readResponse(response) {
    let data = {};

    try {
      data = await response.json();
    } catch (error) {
      data = {};
    }

    if (!response.ok) {
      throw new Error(
        data.description ||
          data.message ||
          'Unable to add this product. Please try again.'
      );
    }

    return data;
  }

  function formatBirthTimeWithAmPm(timeValue) {
    if (!timeValue || timeValue === 'Unknown') return timeValue || '';

    const match = timeValue.match(/^([01]\d|2[0-3]):([0-5]\d)$/);
    if (!match) return timeValue;

    const hour24 = Number(match[1]);
    const minutes = match[2];
    const period = hour24 >= 12 ? 'PM' : 'AM';
    const hour12 = hour24 % 12 || 12;

    return `${hour12}:${minutes} ${period}`;
  }

  function normalizeMembershipTerm(value) {
    const normalized = String(value || '').trim().toLowerCase();

    if (
      normalized === '12m' ||
      normalized === '12-month' ||
      normalized === '12-months' ||
      normalized === '12 months' ||
      normalized === '12'
    ) {
      return '12m';
    }

    if (
      normalized === '6m' ||
      normalized === '6-month' ||
      normalized === '6-months' ||
      normalized === '6 months' ||
      normalized === '6'
    ) {
      return '6m';
    }

    return 'monthly';
  }

  function getMembershipTerm(button) {
    const explicit = button?.dataset?.membershipTerm;
    if (explicit) return normalizeMembershipTerm(explicit);

    const fallbackText = [
      button?.dataset?.productHandle,
      button?.dataset?.productTitle,
      button?.textContent
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    if (fallbackText.includes('12')) return '12m';
    if (fallbackText.includes('6')) return '6m';

    return 'monthly';
  }

  function setButtonLoading(button, loading) {
    if (!button) return;

    const textElement = button.querySelector('.direct-buy-button__text');
    const spinner = button.querySelector('.loading__spinner');

    if (!button.dataset.originalText && textElement) {
      button.dataset.originalText =
        textElement.textContent?.trim() || 'BUY NOW';
    }

    if (loading) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');

      if (textElement) {
        textElement.textContent = 'OPENING CHECKOUT...';
      }

      spinner?.classList.remove('hidden');
      return;
    }

    button.disabled = false;
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');

    if (textElement) {
      textElement.textContent = button.dataset.originalText || 'BUY NOW';
    }

    spinner?.classList.add('hidden');
  }

  function resetV2Loading() {
    document
      .querySelectorAll('[data-direct-buy-v2].loading')
      .forEach((button) => setButtonLoading(button, false));
  }

  window.addEventListener('pagehide', resetV2Loading);
  window.addEventListener('pageshow', resetV2Loading);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      resetV2Loading();
    }
  });

  function initializeV2() {
    const modal = document.querySelector('[data-birth-modal-v2]');
    if (!modal) return;

    const form = modal.querySelector('[data-birth-details-form-v2]');
    const birthDateInput = modal.querySelector('[data-birth-date-v2]');
    const birthTimeInput = modal.querySelector('[data-birth-time-v2]');
    const birthPlaceInput = modal.querySelector('[data-birth-place-v2]');
    const unknownInput = modal.querySelector('[data-birth-time-unknown-v2]');

    const backButton = modal.querySelector('[data-birth-modal-back-v2]');
    const progressText = modal.querySelector('[data-v2-progress-text]');
    const dots = modal.querySelectorAll('[data-v2-dot]');

    const companionCard = modal.querySelector('[data-companion-card-v2]');
    const companionChoice = modal.querySelector('[data-companion-choice-v2]');
    const companionToggle = modal.querySelector('[data-companion-toggle-v2]');
    const companionChoiceState = modal.querySelector('[data-companion-choice-state-v2]');
    const companionPrice = modal.querySelector('[data-companion-price-v2]');
    const companionSavings = modal.querySelector('[data-companion-savings-v2]');
    const companionImage = modal.querySelector('[data-companion-image-v2]');
    const companionPlaceholder = modal.querySelector('[data-companion-placeholder-v2]');
    const companionStatus = modal.querySelector('[data-companion-status-v2]');
    const finalCheckoutButton = modal.querySelector('[data-v2-final-checkout]');
    const finalCheckoutMain = modal.querySelector('[data-v2-checkout-main]');
    const finalCheckoutDetail = modal.querySelector('[data-v2-checkout-detail]');
    const skipCompanionButton = modal.querySelector('[data-v2-skip-companion]');

    const configElement = modal.querySelector('[data-companion-config-v2]');

    let companionConfig = {};
    let pendingButton = null;
    let pendingBirthDetails = null;
    let currentCompanion = null;
    let currentStep = 1;
    let lastFocusedElement = null;

    function readNullableNumber(value) {
      const text = String(value ?? '').trim();
      if (!text) return null;

      const number = Number(text);
      return Number.isFinite(number) ? number : null;
    }

    function readCompanionConfigFromDom() {
      const result = {};

      configElement
        ?.querySelectorAll('[data-companion-config-item-v2]')
        .forEach((item) => {
          const term = normalizeMembershipTerm(item.dataset.term);
          const handle = String(item.dataset.handle || '').trim();

          if (!handle) return;

          result[term] = {
            handle,
            variantId: readNullableNumber(item.dataset.variantId),
            sellingPlanId: readNullableNumber(item.dataset.sellingPlanId),
            sellingPlanName: String(item.dataset.sellingPlanName || '').trim() || null,
            priceCents: readNullableNumber(item.dataset.priceCents),
            compareAtCents: readNullableNumber(item.dataset.compareAtCents),
            months: readNullableNumber(item.dataset.months) || 1,
            termLabel: String(item.dataset.termLabel || '').trim() || 'month',
            image: String(item.dataset.image || '').trim() || null
          };
        });

      return result;
    }

    companionConfig = readCompanionConfigFromDom();

    console.log('ASTRAL V2 config loaded from DOM:', companionConfig);

    const formatter = new Intl.NumberFormat(
      document.documentElement.lang || 'en-US',
      {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }
    );

    function formatMoney(cents) {
      const value = Number(cents);

      if (!Number.isFinite(value)) {
        return '';
      }

      return formatter.format(value / 100);
    }

    function getMonthlyEquivalentCents(config) {
      const months = Number(config?.months || 1);
      const total = Number(config?.priceCents);

      if (!Number.isFinite(total) || months <= 0) {
        return null;
      }

      return Math.round(total / months);
    }

    async function fetchProductJsonConfig(handle) {
      if (!handle) return null;

      const paths = [
        `${shopRoot}products/${encodeURIComponent(handle)}.js`,
        `/products/${encodeURIComponent(handle)}.js`
      ];

      for (const path of [...new Set(paths)]) {
        try {
          const response = await fetch(path, {
            method: 'GET',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            cache: 'no-store'
          });

          if (!response.ok) continue;

          const product = await response.json();
          const variant =
            product?.variants?.find((item) => item?.id) ||
            product?.variants?.[0] ||
            null;

          const allocation =
            variant?.selling_plan_allocations?.[0] ||
            null;

          const sellingPlanId =
            allocation?.selling_plan_id ||
            allocation?.selling_plan?.id ||
            product?.selling_plan_groups?.[0]?.selling_plans?.[0]?.id ||
            null;

          if (!variant?.id) continue;

          return {
            variantId: variant.id,
            sellingPlanId,
            priceCents:
              allocation?.price ??
              variant?.price ??
              product?.price ??
              null,
            compareAtCents:
              allocation?.compare_at_price ??
              variant?.compare_at_price ??
              product?.compare_at_price ??
              null,
            image:
              product?.featured_image ||
              product?.images?.[0] ||
              null
          };
        } catch (error) {
          console.warn('Astral V2 product JSON lookup failed:', path, error);
        }
      }

      return null;
    }

    async function fetchProductPageConfig(handle) {
      if (!handle) return null;

      const paths = [
        `${shopRoot}products/${encodeURIComponent(handle)}`,
        `/products/${encodeURIComponent(handle)}`
      ];

      for (const path of [...new Set(paths)]) {
        try {
          const response = await fetch(path, {
            method: 'GET',
            credentials: 'same-origin',
            headers: { Accept: 'text/html' },
            cache: 'no-store'
          });

          if (!response.ok) continue;

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const variantInput = doc.querySelector(
            'form[action*="/cart/add"] input[name="id"], product-form input[name="id"], input[name="id"][value]'
          );

          const sellingPlanInput = doc.querySelector(
            'form[action*="/cart/add"] [name="selling_plan"], [name="selling_plan"]'
          );

          const ogImage = doc.querySelector('meta[property="og:image"]')?.content || null;
          const priceMeta = doc.querySelector('meta[property="product:price:amount"]')?.content || null;

          let variantId = variantInput?.value || null;
          let sellingPlanId = sellingPlanInput?.value || null;

          if (!variantId) {
            const variantMatch = html.match(/(?:variantId|variant_id|\"id\")\s*[:=]\s*[\"']?(\d{8,})/i);
            variantId = variantMatch?.[1] || null;
          }

          if (!sellingPlanId) {
            const planMatch = html.match(/(?:selling_plan|sellingPlanId|selling_plan_id)\s*[\"']?\s*[:=]\s*[\"']?(\d{6,})/i);
            sellingPlanId = planMatch?.[1] || null;
          }

          const priceCents = priceMeta && !Number.isNaN(Number(priceMeta))
            ? Math.round(Number(priceMeta) * 100)
            : null;

          if (!variantId && !ogImage && !priceCents) continue;

          return {
            variantId,
            sellingPlanId,
            priceCents,
            compareAtCents: null,
            image: ogImage
          };
        } catch (error) {
          console.warn('Astral V2 product-page lookup failed:', path, error);
        }
      }

      return null;
    }

    async function fetchProductConfig(handle) {
      return (
        (await fetchProductJsonConfig(handle)) ||
        (await fetchProductPageConfig(handle)) ||
        null
      );
    }

    async function hydrateCompanionConfig(config) {
      if (!config?.handle) return config;

      const needsFetch =
        !config.variantId ||
        !config.sellingPlanId ||
        !config.priceCents ||
        !config.image;

      if (!needsFetch) return config;

      const fetched = await fetchProductConfig(config.handle);

      if (!fetched) return config;

      return {
        ...config,
        variantId: config.variantId || fetched.variantId,
        sellingPlanId:
          config.sellingPlanId ||
          fetched.sellingPlanId ||
          null,
        priceCents:
          config.priceCents ??
          fetched.priceCents ??
          null,
        compareAtCents:
          config.compareAtCents ??
          fetched.compareAtCents ??
          null,
        image:
          config.image ||
          fetched.image ||
          null
      };
    }

    function setMaximumBirthDate() {
      if (!birthDateInput) return;

      const today = new Date();
      today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
      birthDateInput.max = today.toISOString().split('T')[0];
    }

    function validateBirthDate() {
      if (!birthDateInput) return true;

      birthDateInput.setCustomValidity('');

      if (
        birthDateInput.value &&
        birthDateInput.max &&
        birthDateInput.value > birthDateInput.max
      ) {
        birthDateInput.setCustomValidity(
          'Please enter a birth date that is not in the future.'
        );
        return false;
      }

      return true;
    }

    function updateTimeField() {
      if (!birthTimeInput || !unknownInput) return;

      const isUnknown = unknownInput.checked;

      birthTimeInput.disabled = isUnknown;
      birthTimeInput.required = !isUnknown;
      birthTimeInput.setCustomValidity('');

      if (isUnknown) {
        birthTimeInput.value = '';
      }
    }

    function showStep(step) {
      currentStep = step === 2 ? 2 : 1;

      modal.querySelectorAll('[data-v2-step]').forEach((panel) => {
        panel.hidden = Number(panel.dataset.v2Step) !== currentStep;
      });

      if (backButton) {
        backButton.hidden = currentStep === 1;
      }

      if (progressText) {
        progressText.textContent = `Step ${currentStep} of 2`;
      }

      dots.forEach((dot) => {
        dot.classList.toggle(
          'is-active',
          Number(dot.dataset.v2Dot) === currentStep
        );
      });

      window.setTimeout(() => {
        if (currentStep === 1) {
          birthDateInput?.focus();
        } else {
          companionToggle?.focus();
        }
      }, 40);
    }

    function updateCompanionSelectionUi() {
      if (!companionCard || !companionToggle) return;

      const selected =
        companionToggle.checked &&
        !companionToggle.disabled;

      companionCard.classList.toggle('is-selected', selected);

      if (companionChoiceState) {
        companionChoiceState.textContent = companionToggle.disabled
          ? 'CURRENTLY UNAVAILABLE'
          : selected
            ? 'YES - ADD IT'
            : 'NO - PHYSICAL MAIL ONLY';
      }

      if (companionStatus) {
        if (companionToggle.disabled) {
          companionStatus.textContent =
            'Digital Companion could not be loaded. Continue with Physical Mail only.';
        } else if (selected) {
          const total = formatMoney(currentCompanion?.priceCents);
          const months = Number(currentCompanion?.months || 1);

          if (total && months === 1) {
            companionStatus.textContent =
              `YES - add Digital Companion for +${total}/month`;
          } else if (total) {
            companionStatus.textContent =
              `YES - add Digital Companion for +${total} for ${months} months`;
          } else {
            companionStatus.textContent =
              'YES - add the Digital Companion subscription';
          }
        } else {
          companionStatus.textContent =
            'NO - continue with Physical Mail only';
        }
      }

      if (finalCheckoutMain) {
        finalCheckoutMain.textContent = 'CONTINUE TO CHECKOUT';
      }

      if (finalCheckoutDetail) {
        if (companionToggle.disabled || !selected) {
          finalCheckoutDetail.textContent = 'Physical Mail only';
        } else {
          const total = formatMoney(currentCompanion?.priceCents);
          const months = Number(currentCompanion?.months || 1);

          if (total && months === 1) {
            finalCheckoutDetail.textContent =
              `Physical Mail + ${total}/month Digital Companion`;
          } else if (total) {
            finalCheckoutDetail.textContent =
              `Physical Mail + ${total} for ${months} months Digital Companion`;
          } else {
            finalCheckoutDetail.textContent =
              'Physical Mail + Digital Companion';
          }
        }
      }
    }

    function renderCompanionPricing() {
      const totalCents = Number(currentCompanion?.priceCents);
      const months = Number(currentCompanion?.months || 1);

      if (companionPrice) {
        if (Number.isFinite(totalCents)) {
          if (months === 1) {
            companionPrice.textContent =
              `${formatMoney(totalCents)}/month · subscription`;
          } else {
            const perMonth = getMonthlyEquivalentCents(currentCompanion);

            companionPrice.textContent =
              `${formatMoney(totalCents)} for ${months} months` +
              (perMonth
                ? ` · ${formatMoney(perMonth)}/month`
                : '');
          }
        } else {
          companionPrice.textContent = 'Price shown at checkout';
        }
      }

      if (companionSavings) {
        companionSavings.textContent = '';

        if (months > 1 && Number.isFinite(totalCents)) {
          const monthlyBase = Number(
            companionConfig?.monthly?.priceCents || 240
          );

          const regularTotal = monthlyBase * months;
          const savings = regularTotal - totalCents;

          if (Number.isFinite(savings) && savings > 0) {
            const percent = Math.round(
              (savings / regularTotal) * 100
            );

            companionSavings.textContent =
              `You save ${formatMoney(savings)} (${percent}%)`;
          }
        }
      }
    }

    async function setCompanionForButton(button) {
      const term = getMembershipTerm(button);
      const rawConfig =
        companionConfig[term] ||
        null;

      currentCompanion = rawConfig
        ? { ...rawConfig, term }
        : null;

      if (companionPrice) {
        companionPrice.textContent = 'Loading price…';
      }

      if (companionSavings) {
        companionSavings.textContent = '';
      }

      if (currentCompanion) {
        currentCompanion =
          await hydrateCompanionConfig(currentCompanion);
      }

      if (term === 'monthly' && currentCompanion) {
        currentCompanion.priceCents =
          currentCompanion.priceCents || 240;

        currentCompanion.image =
          currentCompanion.image ||
          'https://astralbysanti.com/cdn/shop/files/Monthly_Add_On.png?v=1788239241&width=420';
      }

      /*
       * Subscription-only Companion:
       * - show the offer whenever its product config exists
       * - real checkout requires BOTH variantId and sellingPlanId
       * - we never add the Companion as a one-time item
       */
      const usable = Boolean(
        currentCompanion &&
        currentCompanion.variantId &&
        currentCompanion.sellingPlanId
      );

      const displayable = Boolean(currentCompanion);

      if (companionImage) {
        if (currentCompanion?.image) {
          companionImage.src = currentCompanion.image;
          companionImage.hidden = false;
          companionPlaceholder?.setAttribute('hidden', '');
        } else {
          companionImage.removeAttribute('src');
          companionImage.hidden = true;
          companionPlaceholder?.removeAttribute('hidden');
        }
      }

      renderCompanionPricing();

      if (companionToggle) {
        companionToggle.disabled = !displayable;
        companionToggle.checked = displayable;
      }

      companionCard?.classList.toggle('is-unavailable', !displayable);

      updateCompanionSelectionUi();

      console.log('ASTRAL V2 Companion config:', {
        term,
        handle: currentCompanion?.handle || null,
        variantId: currentCompanion?.variantId || null,
        sellingPlanId: currentCompanion?.sellingPlanId || null,
        sellingPlanName: currentCompanion?.sellingPlanName || null,
        priceCents: currentCompanion?.priceCents ?? null,
        subscriptionReady: usable
      });

      return usable;
    }

    function openModal(button) {
      pendingButton = button;
      pendingBirthDetails = null;
      lastFocusedElement = document.activeElement;

      setMaximumBirthDate();
      updateTimeField();
      setCompanionForButton(button).catch((error) => {
        console.warn('Astral V2 prefetch error:', error);
      });
      showStep(1);

      modal.hidden = false;
      document.body.classList.add('astral-v2-modal-open');

      window.setTimeout(() => birthDateInput?.focus(), 50);
    }

    function closeModal({ restoreFocus = true } = {}) {
      modal.hidden = true;
      document.body.classList.remove('astral-v2-modal-open');

      pendingButton = null;
      pendingBirthDetails = null;
      currentCompanion = null;
      currentStep = 1;

      if (restoreFocus && lastFocusedElement instanceof HTMLElement) {
        lastFocusedElement.focus();
      }
    }

    function buildPhysicalProperties(birthDetails) {
      return {
        // '_Birth date': birthDetails.birthDate,
        // '_Birth time': birthDetails.birthTimeUnknown
        //   ? 'Unknown'
        //   : birthDetails.birthTime,
        // '_Birth place': birthDetails.birthPlace,
        '_Birth time unknown': birthDetails.birthTimeUnknown ? 'Yes' : 'No',
        // '_Birth details source': 'Membership signup',
        'Date of birth': birthDetails.birthDate,
        'Time of birth': birthDetails.birthTimeUnknown
          ? 'Unknown'
          : formatBirthTimeWithAmPm(birthDetails.birthTime),
        'Place of birth': birthDetails.birthPlace,
        'Preferred Name': ''
      };
    }

    function buildCompanionProperties(birthDetails, term) {
      return {
        // '_Birth date': birthDetails.birthDate,
        // '_Birth time': birthDetails.birthTimeUnknown
        //   ? 'Unknown'
        //   : birthDetails.birthTime,
        // '_Birth place': birthDetails.birthPlace,
        // '_Birth time unknown': birthDetails.birthTimeUnknown ? 'Yes' : 'No',
        '_Birth details source': 'Membership signup companion',
        '_Companion membership term': term
      };
    }

    async function completeDirectBuyV2(button, birthDetails, includeCompanion) {
      const variantId = button?.dataset?.variantId;
      const sellingPlanId = button?.dataset?.sellingPlanId;
      const requiresSellingPlan =
        button?.dataset?.requiresSellingPlan === 'true';
      const uiOnly = button?.dataset?.v2UiOnly === 'true';
      const term = getMembershipTerm(button);

      if (uiOnly) {
        const testPayload = {
          membershipTerm: term,
          physicalVariantId: variantId || '(UI test only)',
          physicalSellingPlanId: sellingPlanId || null,
          companionSelected: Boolean(includeCompanion),
          companionVariantId: includeCompanion
            ? currentCompanion?.variantId || null
            : null,
          companionSellingPlanId: includeCompanion
            ? currentCompanion?.sellingPlanId || null
            : null,
          birthDetails
        };

        console.log('ASTRAL V2 UI TEST COMPLETE:', testPayload);

        const testStatus = document.querySelector('[data-v2-test-result]');
        if (testStatus) {
          testStatus.textContent = includeCompanion
            ? currentCompanion?.sellingPlanId
              ? `Test complete: ${term} Physical Mail + Digital Companion subscription selected. Variant ${currentCompanion?.variantId || '—'} · Plan ${currentCompanion.sellingPlanId}. No cart changes were made.`
              : `Test found the Companion product, but no selling plan ID was returned. No cart changes were made.`
            : `Test complete: ${term} Physical Mail only selected. No cart changes were made.`;
          testStatus.hidden = false;
        }

        closeModal({ restoreFocus: false });
        return;
      }

      if (!variantId) {
        window.alert('No available physical membership variant was found.');
        return;
      }

      if (requiresSellingPlan && !sellingPlanId) {
        window.alert('No subscription plan was found for this membership.');
        return;
      }

      if (
        includeCompanion &&
        currentCompanion &&
        (!currentCompanion.variantId || !currentCompanion.sellingPlanId)
      ) {
        currentCompanion = await hydrateCompanionConfig({
          ...currentCompanion
        });
      }

      if (
        includeCompanion &&
        (!currentCompanion ||
          !currentCompanion.variantId ||
          !currentCompanion.sellingPlanId)
      ) {
        console.error('Astral V2 Companion subscription is incomplete:', currentCompanion);

        window.alert(
          'The Digital Companion subscription plan could not be loaded. The Companion was NOT added as a one-time purchase. Please check the Companion selling plan setup.'
        );
        return;
      }

      setButtonLoading(button, true);

      try {
        const clearResponse = await fetch(`${shopRoot}cart/clear.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        await readResponse(clearResponse);

        const physicalItem = {
          id: Number(variantId),
          quantity: 1,
          properties: buildPhysicalProperties(birthDetails)
        };

        if (sellingPlanId) {
          physicalItem.selling_plan = Number(sellingPlanId);
        }

        const items = [physicalItem];

        if (
          includeCompanion &&
          currentCompanion?.variantId &&
          currentCompanion?.sellingPlanId
        ) {
          const companionItem = {
            id: Number(currentCompanion.variantId),
            quantity: 1,
            selling_plan: Number(currentCompanion.sellingPlanId),
            properties: buildCompanionProperties(birthDetails, term)
          };

          items.push(companionItem);
        }

        const addResponse = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        await readResponse(addResponse);

        console.log('Astral Direct Buy V2:', {
          physicalVariantId: variantId,
          physicalSellingPlanId: sellingPlanId || null,
          membershipTerm: term,
          companionIncluded: Boolean(includeCompanion),
          companionVariantId: includeCompanion
            ? currentCompanion?.variantId || null
            : null,
          companionSellingPlanId: includeCompanion
            ? currentCompanion?.sellingPlanId || null
            : null
        });

        window.location.assign(`${shopRoot}checkout`);
      } catch (error) {
        console.error('Astral Direct Buy V2 error:', error);

        window.alert(
          error.message || 'Unable to open checkout. Please try again.'
        );

        setButtonLoading(button, false);
      }
    }

    birthDateInput?.addEventListener('change', validateBirthDate);
    unknownInput?.addEventListener('change', updateTimeField);
    companionToggle?.addEventListener('change', updateCompanionSelectionUi);

    companionChoice?.addEventListener('click', (event) => {
      if (!companionToggle || companionToggle.disabled) return;

      if (event.target.closest('input')) return;

      event.preventDefault();
      companionToggle.checked = !companionToggle.checked;
      updateCompanionSelectionUi();
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!pendingButton) return;

      updateTimeField();

      if (!unknownInput?.checked && !birthTimeInput?.value) {
        birthTimeInput?.setCustomValidity(
          'Enter your birth time or select that it is unknown.'
        );
      }

      validateBirthDate();

      if (!form.reportValidity()) return;

      birthTimeInput?.setCustomValidity('');

      pendingBirthDetails = {
        birthDate: birthDateInput.value,
        birthTime: unknownInput.checked ? 'Unknown' : birthTimeInput.value,
        birthPlace: birthPlaceInput.value.trim(),
        birthTimeUnknown: unknownInput.checked
      };

      await setCompanionForButton(pendingButton);
      showStep(2);
    });

    backButton?.addEventListener('click', (event) => {
      event.preventDefault();
      showStep(1);
    });

    skipCompanionButton?.addEventListener('click', async (event) => {
      event.preventDefault();

      if (!pendingButton || !pendingBirthDetails) return;

      if (companionToggle) {
        companionToggle.checked = false;
        updateCompanionSelectionUi();
      }

      const button = pendingButton;
      const birthDetails = pendingBirthDetails;

      modal.hidden = true;
      document.body.classList.remove('astral-v2-modal-open');

      await completeDirectBuyV2(button, birthDetails, false);
    });

    finalCheckoutButton?.addEventListener('click', async (event) => {
      event.preventDefault();

      if (!pendingButton || !pendingBirthDetails) return;

      const button = pendingButton;
      const birthDetails = pendingBirthDetails;
      const includeCompanion = Boolean(
        companionToggle?.checked && !companionToggle?.disabled
      );

      modal.hidden = true;
      document.body.classList.remove('astral-v2-modal-open');

      await completeDirectBuyV2(button, birthDetails, includeCompanion);
    });

    document.addEventListener('click', (event) => {
      const v2Button = event.target.closest('[data-direct-buy-v2]');

      if (v2Button) {
        event.preventDefault();

        if (
          v2Button.disabled ||
          v2Button.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        openModal(v2Button);
        return;
      }

      const closeButton = event.target.closest('[data-birth-modal-close-v2]');
      if (closeButton && !modal.hidden) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    modal.addEventListener('click', function (event) {
      if (
        event.target === modal ||
        event.target.classList.contains('astral-v2-modal__overlay')
      ) {
        closeModal();
      }
    });

    setMaximumBirthDate();
    updateTimeField();
    resetV2Loading();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeV2, { once: true });
  } else {
    initializeV2();
  }
})();
